import { GetData } from "../../utils/axios";
import {
  ADD_SAMVERKANSPART_USERS,
  CHANGE_REQUIRED_FIELDS,
  SET_ARRANGEMANG_OVERVIEW,
  ADD_ARR_ARTISTER,
  CLEAR_ARR_ARTISTER,
  ADD_NOTISER,
  SET_ACTIVE_STEP,
  SET_CURRENTWIZARD_STEP,
} from "../constants/constants";

export const clearArrArtister = () => (dispatch) => {
  dispatch({ type: CLEAR_ARR_ARTISTER });
};

export const addSamverkansPartUsers = (value) => ({
  type: ADD_SAMVERKANSPART_USERS,
  payload: value,
});

export const changeRequiredFields = (value) => ({
  type: CHANGE_REQUIRED_FIELDS,
  payload: value,
});

export const setArrangemangOverview = (value) => ({
  type: SET_ARRANGEMANG_OVERVIEW,
  payload: value,
});

export const setActiveStep = (value) => ({
  type: SET_ACTIVE_STEP,
  payload: value,
});

export const setCurrentWizardStep = (value) => ({
  type: SET_CURRENTWIZARD_STEP,
  payload: value,
});

export function fetchNotiser(createDynamicNotis = false) {
  let url = "/notiser";
  if (createDynamicNotis) {
    url += "?createDynamicNotis=true";
  }
  return function (dispatch) {
    return GetData(url).then((data) => {
      if (data) {
        dispatch({
          type: ADD_NOTISER,
          payload: data,
        });
      }
    });
  };
}

//REFACTOR To fetchDeltagare with option of roll
export function fetchArtister(value) {
  if (value) {
    const arrId = value.arrId;
    const roll = value.roll;
    const url = `/arrangemangs/${arrId}/arrdeltagares/&roll=${roll}`;

    return function (dispatch) {
      return GetData(url).then((data) => {
        dispatch({
          type: ADD_ARR_ARTISTER,
          payload: data.result,
        });
      });
    };
  }
}
